"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputValueControl = void 0;
const react_1 = require("react");
const useInputValueControl = (inputRef) => {
    const setNativeValue = react_1.useCallback((newValue) => {
        const element = inputRef.current;
        // @ts-ignore
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        // @ts-ignore
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;
        if (valueSetter && valueSetter !== prototypeValueSetter) {
            // @ts-ignore
            prototypeValueSetter.call(element, newValue);
        }
        else {
            // @ts-ignore
            valueSetter.call(element, newValue);
        }
    }, [inputRef]);
    return react_1.useCallback((newValue) => {
        setNativeValue(newValue);
        const event = new Event('input', { bubbles: true });
        inputRef.current.dispatchEvent(event);
    }, [inputRef, setNativeValue]);
};
exports.useInputValueControl = useInputValueControl;
